import { apiGet } from '@/utils/request';

export function getAll(query) {
  return apiGet(`${BASE_API_URL}/services/app/Exception/GetAll`, query);
}

export function get(query = {}) {
  return apiGet(`${BASE_API_URL}/services/app/Exception/Get`, query);
}
